import React from 'react';

interface FilterOption {
  value: string;
  label: string;
}

interface FilterBarProps {
  searchPlaceholder?: string;
  searchValue: string;
  onSearchChange: (value: string) => void;
  filters?: Array<{
    key: string;
    label: string;
    value: string;
    onChange: (value: string) => void;
    options: FilterOption[];
  }>;
  onClear?: () => void;
}

export const FilterBar: React.FC<FilterBarProps> = ({
  searchPlaceholder = '🔍 Rechercher...',
  searchValue,
  onSearchChange,
  filters = [],
  onClear,
}) => {
  const hasActiveFilters = searchValue || filters.some(f => f.value !== '');

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 mb-6">
      <div className="flex flex-col md:flex-row gap-4 items-center">
        {/* Barre de recherche */}
        <div className="flex-1 w-full md:w-auto">
          <input
            type="text"
            placeholder={searchPlaceholder}
            value={searchValue}
            onChange={(e) => onSearchChange(e.target.value)}
            className="w-full px-4 py-2 border-2 border-green-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all bg-white text-sm"
          />
        </div>

        {/* Filtres */}
        {filters.map((filter) => (
          <div key={filter.key} className="w-full md:w-auto">
            <select
              value={filter.value}
              onChange={(e) => filter.onChange(e.target.value)}
              className="w-full px-4 py-2 border-2 border-green-200 rounded-xl focus:ring-2 focus:ring-green-500 focus:border-green-500 transition-all bg-white text-sm"
            >
              <option value="">{filter.label}</option>
              {filter.options.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        ))}

        {/* Bouton de réinitialisation */}
        {hasActiveFilters && onClear && (
          <button
            onClick={onClear}
            className="px-4 py-2 bg-gray-200 hover:bg-gray-300 text-gray-700 rounded-xl font-semibold transition-colors text-sm whitespace-nowrap"
          >
            🔄 Réinitialiser
          </button>
        )}
      </div>
    </div>
  );
};


